<template>
  <ClientOnly>
    <div>
      <PrimeButton
        @click="toggleDarkMode"
        :icon="settingsStore.isDarkMode ? 'pi pi-sun' : 'pi pi-moon'"
        text
        severity="contrast"
        class="transition-all duration-200"
        aria-label="Toggle dark mode"
        size="small"
      />
    </div>
  </ClientOnly>
</template>

<script setup>
import { useSettingsStore } from '~/stores/settings';

const settingsStore = useSettingsStore();

const toggleDarkMode = () => {
  settingsStore.toggleDarkMode();
};
</script>
